import React from 'react';
import RadioGroupEdit from '@atlassian/jira-issue-field-radio-group/src/ui/edit/index.tsx';
import { mapDataToOptions } from '@atlassian/jira-issue-field-radio-group/src/ui/edit/utils.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { validateRadioGroupField } from '../../common/utils/validators/index.tsx';
import type { Props, RadioGroupFieldConfig, FieldValue } from './types.tsx';
import { transformDefaultValue } from './utils.tsx';

const RadioGroupField = (props: Props): React.JSX.Element => {
	const {
		width,
		fieldProps: { value, onChange, isDisabled = false, ...fieldProps },
		error,
		allowedValues,
		isReadOnly = false,
	} = props;
	const options = mapDataToOptions(allowedValues);
	return (
		<FieldContainer width={width}>
			<RadioGroupEdit
				{...fieldProps}
				options={options}
				isDisabled={isReadOnly || isDisabled}
				value={value}
				onChange={onChange}
				isInvalid={Boolean(error)}
			/>
		</FieldContainer>
	);
};

export default withFormField({ validator: validateRadioGroupField, transformDefaultValue })<
	RadioGroupFieldConfig,
	FieldValue
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<RadioSelectFieldConfig, Option>, any>'.
>(RadioGroupField);

export { RadioGroupField };
